import WebpImage from '@r1-frontend/ui-react/components/WebpImage';

import * as ST from './styled';

const Header = () => {

    return (
        <ST.Header>
            <ST.Container>
                <ST.Title>
                    Свяжитесь с&nbsp;нами любым удобным способом
                </ST.Title>
                <ST.ImageWrapper>
                    <WebpImage urlWebp={'/static/images/service/contact/header-bg.webp'}>
                        <img src={'/static/images/service/contact/header-bg.png'} alt={'Изображение с примерами способов связи'} />
                    </WebpImage>
                </ST.ImageWrapper>
            </ST.Container>
        </ST.Header>
    );
};

export default Header;
